<template>
  <div>
    <Header :isactive="6" :ischunrk="true" :key="new Date().getTime()" />
    <div style="height: 60px;"></div>
    <!-- <div id="banner">
      <img src="@/assets/image/banner-rule.jpg" alt="">
    </div> -->
    <div id="contact-us">
      <div class="us-content">
        <div class="title-content">
          <p class="trans">LCD panel manufacturing</p>
          <p class="title">液晶面板制造业</p>
        </div>
        <ul class="ul-content">
          <li class="li-item first">
            <img class="bg-serve" src="@/assets/image/product/lcd_01.jpg" alt="" />
            <div class="desc-content">
              <p class="desc"></p>
              <div class="site-link">
                <div class="go-to">
                  <router-link :to="{ path: '/LCDPanel' }" target="_blank">
                    <img src="@/assets/image/go-to.png" alt="" />
                  </router-link>
                </div>
              </div>
            </div>
          </li>
          <li class="li-item first">
            <img class="bg-serve" src="@/assets/image/product/lcd_02.jpg" alt="" />
            <div class="desc-content">
              <p class="desc"></p>
              <div class="site-link">
                <div class="go-to">
                  <router-link :to="{ path: '/LCDPanel' }" target="_blank">
                    <img src="@/assets/image/go-to.png" alt="" />
                  </router-link>
                </div>
              </div>
            </div>
          </li>
          <li class="li-item first">
            <img class="bg-serve" src="@/assets/image/product/lcd_03.jpg" alt="" />
            <div class="desc-content">
              <p class="desc"></p>
              <div class="site-link">
                <div class="go-to">
                  <router-link :to="{ path: '/LCDPanel' }" target="_blank">
                    <img src="@/assets/image/go-to.png" alt="" />
                  </router-link>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <Footer />
    <Top />
  </div>
</template>

<script>
import Header from "@/components/Header/index.vue";
import Footer from "@/components/Footer/index.vue";
import Top from "@/components/Top/index.vue";

export default {
  components: { Header: Header, Footer: Footer, Top: Top },
  data() {
    return {
      ad5: false,
      ad6: false,
      ad7: false,
      ad8: false
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  }
};
</script>
<style lang="scss" scoped>
$active: #13c2c2;
$width: 1200px;
$banner-height: 632px;
$font: 14px;
$trans: 0.25;
$opacity: 0.85;
$time-height: 110px;

#contact-us {
  padding: 120px 0px;

  .us-content {
    width: $width;
    margin: 0 auto;
    .ul-content {
      margin-top: 60px;
    }
    .us-list {
      margin-top: 60px;

      p {
        font-size: 16px;
        color: rgba(0, 0, 0, 0.85);
        line-height: 30px;
      }

      .title {
        font-weight: 600;
      }

      .text {
        margin-bottom: 24px;
      }

      .title-text {
        margin-bottom: 48px;
      }

      .email-msg {
        opacity: 0.65;
      }

      .email-img {
        margin: 6px 0px;
      }
    }
  }
}

#banner {
  width: 100%;
  height: 482px;

  img {
    width: 100%;
    min-width: 1920px;
    display: block;
  }
}

.title-content {
  text-align: center;

  .title {
    font-size: 30px;
    height: 36px;
    line-height: 36px;
  }

  .icon {
    margin: 10px auto;
    height: 2px;
    width: 24px;
    background: $active;
  }

  .trans {
    font-size: $font;
    opacity: $trans;
  }
}
</style>
